import { render, staticRenderFns } from "./page-footModule.vue?vue&type=template&id=95115c56&scoped=true"
import script from "./page-footModule.vue?vue&type=script&lang=js"
export * from "./page-footModule.vue?vue&type=script&lang=js"
import style0 from "./page-footModule.vue?vue&type=style&index=0&id=95115c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95115c56",
  null
  
)

export default component.exports